import TokenUtil from '../../utils/TokenizedUrl';
import PicGetRequest from '../PicGetRequest';
import { prtErr } from '../../utils/prt';


/* Note, the payload itself has the parms need to make the api call  */
const contactExist = (payload) => {
   
    let _self = this;
    let apiPromise  = new Promise (function resolver(resolve, reject) {   

            /* pull out fields from payload needed to process api call and log error messages. */
            let organizerEmail = payload.uid;
            let contactEmail   = payload.eid;

            /* generate a JWT token with the payload */
            let tokenUtil  = new TokenUtil();
            tokenUtil.setPayload(payload)
            let token = tokenUtil.getToken();

            /* make api call */
            let getContactRequest = new PicGetRequest("GetContactRequest");
            getContactRequest.setUserId(organizerEmail)
                .setUri("/organizer/contact")
                .setAuthToken(token)  /* set token for internal request */
                .setLogTrace(false);
            getContactRequest.exec().then((response) => {
                let contact = response.data;
                resolve(contact)
            }).catch((err) => {
                let error = getContactRequest.getError();
                if (error.status === 404) {
                    resolve({contact: ''});
                } else {
                    prtErr(`Error: encountered when calling contactExist api on behalf of ${organizerEmail} for contact ${contactEmail}`);
                    reject(error)
                }
            })
    }); /* end Promise */
    return apiPromise;
}

export default contactExist;





// WEBPACK FOOTER //
// ./src/apis/contact/contactExist.js